import React, { useContext as useContextCore } from 'react'
import type { Blog } from '@ztechapps/common.contract'

export type ContextType = { posts: Blog[]; tags: string[] }

const context = React.createContext<ContextType>({ posts: [], tags: [] })
const CoreProvider = context.Provider

export const Provider = ({ children, posts, tags }) => {
  return <CoreProvider value={{ posts, tags }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
